import { AxiosInstance } from 'axios';
import {
	OutlookCalendarCategory,
	OutlookFolder,
} from './OutlookSourceSettings.types';

export class OutlookSourceSettingsApi {
	constructor(private client: AxiosInstance) {}

	async getMailFolders(
		boardId: string,
		connectionId: string,
	): Promise<OutlookFolder[]> {
		const response = await this.client.get<OutlookFolder[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/outlookmail/folders`,
		);

		return response.data;
	}

	async getTaskFolders(
		boardId: string,
		connectionId: string,
	): Promise<OutlookFolder[]> {
		const response = await this.client.get<OutlookFolder[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/outlooktasks/folders`,
		);

		return response.data;
	}

	async getCalendarCategories(
		boardId: string,
		connectionId: string,
	): Promise<OutlookCalendarCategory[]> {
		const response = await this.client.get<OutlookCalendarCategory[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/o365calendar/categories`,
		);

		return response.data;
	}
}
